import { Button, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export function columnSearch(title, getValue) {
  return {
    key: title,
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 10, width: 260 }} onKeyDown={event => event.stopPropagation()}>
        <Input autoFocus aria-label={`Search ${title}`} placeholder={`Search ${title}`}
          value={selectedKeys[0] || ''}
          onChange={event => setSelectedKeys(event.target.value ? [event.target.value] : [])}
          onPressEnter={() => confirm()} style={{ marginBottom: 10 }} />
        <Space>
          <Button type="primary" size="small" onClick={() => confirm()}>Apply</Button>
          <Button size="small" onClick={() => { clearFilters?.(); confirm(); }}>Reset</Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined aria-label={`Filter ${title}`} style={{ color: filtered ? '#6366f1' : undefined }} />,
    onFilter: (query, row) => String(getValue(row) ?? '').toLocaleLowerCase().includes(String(query).trim().toLocaleLowerCase()),
  };
}

export function columnValueFilter(title, rows, getValue) {
  const values = [...new Set(rows.map(row => String(getValue(row) ?? 'Not reported')))].sort((a,b) => a.localeCompare(b));
  return {
    key: title,
    filters: values.map(value => ({ text: value, value })),
    filterSearch: true,
    filterMultiple: true,
    filterIcon: filtered => <SearchOutlined aria-label={`Filter ${title}`} style={{ color: filtered ? '#6366f1' : undefined }} />,
    onFilter: (value, row) => String(getValue(row) ?? 'Not reported') === value,
  };
}
